
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const navigate = useNavigate();
  const [user] = useState({
    name: 'أحمد محمد العلي',
    email: 'ahmed.ali@email.com',
    phone: '+966 50 123 4567',
    avatar: 'https://public.readdy.ai/ai/img_res/21787f851f6099c8466b391be4c0acb7.jpg',
    joinDate: 'انضم في يناير 2023',
    totalFlights: 24,
    totalConnections: 156,
    rating: 4.8
  });

  const [stats] = useState([
    { label: 'الرحلات', value: user.totalFlights, icon: 'ri-flight-takeoff-line', color: 'blue' },
    { label: 'الاتصالات', value: user.totalConnections, icon: 'ri-group-line', color: 'green' },
    { label: 'التقييم', value: user.rating, icon: 'ri-star-line', color: 'yellow' }
  ]);

  const [menuItems] = useState([
    { icon: 'ri-user-settings-line', title: 'تعديل الملف الشخصي', subtitle: 'معلوماتك الشخصية', action: () => navigate('/edit-profile') },
    { icon: 'ri-history-line', title: 'سجل الرحلات', subtitle: 'جميع رحلاتك السابقة', action: () => navigate('/flight-history') },
    { icon: 'ri-chat-history-line', title: 'سجل المحادثات', subtitle: 'المحادثات المحفوظة', action: () => navigate('/chat-history') },
    { icon: 'ri-shield-check-line', title: 'الخصوصية والأمان', subtitle: 'إعدادات الأمان', action: () => navigate('/privacy') },
    { icon: 'ri-notification-3-line', title: 'إعدادات الإشعارات', subtitle: 'تخصيص الإشعارات', action: () => navigate('/notification-settings') },
    { icon: 'ri-question-line', title: 'المساعدة والدعم', subtitle: 'الأسئلة الشائعة', action: () => navigate('/help') },
    { icon: 'ri-information-line', title: 'حول التطبيق', subtitle: 'معلومات التطبيق', action: () => navigate('/about') }
  ]);

  const getColorClasses = (color: string) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-600',
      green: 'bg-green-100 text-green-600',
      yellow: 'bg-yellow-100 text-yellow-600'
    };
    return colors[color as keyof typeof colors] || colors.blue;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 pt-12 pb-8 px-6">
        <div className="flex items-center justify-between mb-6">
          <button 
            onClick={() => navigate('/main')}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          
          <h1 className="text-lg font-bold text-white font-arabic">الملف الشخصي</h1>
          
          <button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-more-line text-white text-lg"></i>
          </button>
        </div>

        {/* Profile Card */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white text-center">
          <img 
            src={user.avatar} 
            alt="Profile" 
            className="w-20 h-20 rounded-full mx-auto mb-4 object-cover border-4 border-white/20"
          />
          <h2 className="text-xl font-bold mb-1 font-arabic">{user.name}</h2>
          <p className="text-white/80 text-sm mb-2 font-arabic">{user.email}</p>
          <p className="text-white/60 text-xs font-arabic">{user.joinDate}</p>
        </div>
      </div>

      {/* Stats */}
      <div className="px-6 -mt-4 mb-6">
        <div className="bg-white rounded-2xl p-6 shadow-lg">
          <div className="grid grid-cols-3 gap-4">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-2 ${getColorClasses(stat.color)}`}>
                  <i className={`${stat.icon} text-lg`}></i>
                </div>
                <div className="text-lg font-bold text-gray-800">{stat.value}</div>
                <div className="text-sm text-gray-600 font-arabic">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div className="px-6">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.action}
              className="w-full flex items-center p-4 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100 last:border-b-0"
            >
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center ml-4">
                <i className={`${item.icon} text-gray-600`}></i>
              </div>
              
              <div className="flex-1 text-right">
                <h3 className="font-medium text-gray-800 font-arabic">{item.title}</h3>
                <p className="text-sm text-gray-500 font-arabic">{item.subtitle}</p>
              </div>
              
              <i className="ri-arrow-left-s-line text-gray-400"></i>
            </button>
          ))}
        </div>
      </div>

      {/* Logout Button */}
      <div className="px-6 mt-6 mb-20">
        <button 
          onClick={() => navigate('/auth')}
          className="w-full bg-red-50 text-red-600 p-4 rounded-xl font-medium hover:bg-red-100 transition-colors duration-200 font-arabic"
        >
          تسجيل الخروج
        </button>
      </div>

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}